import { AxiosResponse } from 'axios'
import  { Moment } from 'moment'

import ClientSDK from '../../../App/ClientSDK'

type EditPerson = {
  uuid: string
  firstName: string
  lastName: string
  email: string
}

class Client {
  static editPerson = (
    uuid: string,
    firstName: string,
    lastName: string,
    email: string,
    hasToPunch: boolean,
    newPassword?: string,
    selectedDate?: Moment,
  ): Promise<EditPerson> => {
    const convertedDate = selectedDate
      ? selectedDate.format('YYYY-MM-DD')
      : null
    return ClientSDK.instance()
      .put(`hr/persons/${uuid}`, {
        first_name: firstName,
        last_name: lastName,
        has_to_punch: hasToPunch,
        email,
        ...(newPassword && { password: newPassword }),
        ...(convertedDate && { starts_at: convertedDate }),
      })
      .then((response: AxiosResponse): EditPerson => {
        return response.data
      })
  }
}

export default Client
